import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import { MIconButton } from 'src/theme';
import journal from "src/utils/journal/journal";
import { requestErrorData } from "src/utils/journal/uiErrorCapture";

export default function MyAutoSnack(
  variant,
  text,
  enqueueSnackbar,
  closeSnackbar,
  // Opcional: el error original (axios) para registrar estado, código y endpoint.
  error
) {
  // Diario TPV: errores que ve el camarero (solo graba en pantallas TPV).
  if (variant === "error") {
    journal.track("ui.error", {
      message: typeof text === "string" ? text.slice(0, 200) : null,
      ...(requestErrorData(error) || {}),
    });
  }
  return enqueueSnackbar(text, {
    variant,
    action: (key) => (
      <MIconButton size="small" onClick={() => closeSnackbar(key)}>
        <Icon icon={closeFill} />
      </MIconButton>
    )
  });
}
